// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreDetails_container__1aebh","title":"MoreDetails_title__3giAM","content":"MoreDetails_content__2YB2b","detailsItem":"MoreDetails_detailsItem__2jcyQ"};